import React, { useContext, useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate
} from 'react-router-dom';

import { trackPage } from './analytics.js'; // sau ./analytics dacă redenumești

import { Header } from './header/Header';
import { Home } from './content/Home';
import { About } from './footer/About';
import CursuriPresentation from './footer/CursuriPresentation';
import JocuriPresentation from './footer/JocuriPresentation';

import { Registrer } from './content/Registrer';
import { Login } from './content/Login';
import { AuthProvider } from './AuthContext';
import { DarkModeProvider, useDarkMode } from './DarkModeContext';
import LoadingOverlay from './content/LoadingOverlay';
import Maintenance from './Maintenance';
import './styles/darkmode.css';





import MenuFooter from './footer/MenuFooter';



import EmailConnect from './content/EmailConnect';
import ForgotPassword from './content/ForgotPassword';
import ResetPassword from './content/ResetPassword';

import RedirectAfterLogin from './RedirectAfterLogin';

import ConfirmationPage from './content/ConfirmationPage';
// ...existing code...
import ShowLessonsFinanciara from './content/functionalpagelogin/ShowLessonsFinanciara';
import { LessonsGameFunctionalRules } from './games/LessonsGameFunctionalRules'
import { LessonsGameTipeAccount } from './games/LessonsGameTipeAccount'
import { LessonsGameAccountsPlan } from './games/LessonsGameAccountsPlan'











import GameFunctionalRules from './games/GameFunctionalRules';
import GameTipeAccount from './games/GameTipeAccount';
import GameAccountsPlan from './games/GameAccountsPlan';








import { Footer } from './footer/Footer';
import './App.css';
import { LessonsContainer } from './content/lessons/LessonsContainer';


import Viewplans from './header/offer/Viewplans';

import Finaloffer from './header/offer/Finaloffer';

import Paymentpage from './header/offer/Paymentpage';

import Facturare from './header/offer/Facturare';
import ResetareProgres from './content/ResetareProgres';
import LessonsLayout from './content/LessonsLayout';

import PlanLunar from './header/offer/PlanLunar';
import PlanAnual from './header/offer/PlanAnual';
import PlanGratuit from './header/offer/PlanGratuit';



import Clasament from './content/clasament/Clasament';
import Headerbc from "./content/Headerbc";

import BazeleConta from './content/coursesandgamespage/BazeleConta';
import ContaFinanciara from './content/coursesandgamespage/ContaFinanciara';
import PageGameFinancialRulesOff from './content/coursesandgamespage/PageGameFinancialRulesOff';
import PageGameTypeAccountOff from './content/coursesandgamespage/PageGameTypeAccountOff';
import PageGameAccoutPlanOff from './content/coursesandgamespage/PageGameAccoutPlanOff';

import FunctionalPageLoginStart from './content/functionalpagelogin/FunctionalPageLoginStart.jsx';




import Blog from './content/functionalpagelogin/InsideFooter/Blog';
import CheckCertification from './content/functionalpagelogin/InsideFooter/CheckCertification';


import QuizStart from './quizstart/QuizStart';
import ScrollToTop from './ScrollToTop';
import Chaptercontainer from './content/bazelecontabilitatii/Chaptercontainer';
import Chaptercontainercf from './content/contafinanciara/Chaptercontainercf';
import UserPage from './users/UserPage';
import Showgames from './games/Showgames';
import Setari from './users/Setari';
import PlanulTau from './users/PlanulTau';
import Settings from './settings/Settings';
import Ajutor from './users/Ajutor';
//import ProtectedRoute from './ProtectedRoute';
import Cursuri from './content/coursespage/Cursuri';
import Diploma from './diploma/Diploma';
import Diplome from './users/Diplome';
import CoursesProgressPage from './users/CoursesProgressPage';
import Medals from './users/Medals';

import FAQ from './footer/FAQ';
import Termeni from './footer/Termeni';

import Cariere from './footer/Cariere';
import { Feedback } from './footer/Feedback';




import Politica from './footer/Politica';
import Politicacookies from './footer/Politicacookies';
import GDPR from './footer/GDPR';
import ANPC from './footer/ANPC';
//import { publicRoutes } from './content/publicRoutes';

import CookieConsent from './CookieConsent'; 






// Adaugă URL-ul API-ului folosind variabila de mediu
const apiUrl = process.env.REACT_APP_API_URL;


function AppContent() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const { user, loading: authLoading } = require('./AuthContext').useAuth();




useEffect(() => {
  trackPage(location.pathname + location.search);
}, [location]);



     // pornește overlay la fiecare schimbare de rută
  useEffect(() => {
    setLoading(true);
    const t = setTimeout(() => setLoading(false), 100); // 0.6s pauză
    return () => clearTimeout(t);
  }, [location.pathname]);

  const lessonIsActive = location.pathname === '/chaptercontainer';
  const lessonCfIsActive = location.pathname === '/chaptercontainercf';
  const showLessonIsActive = location.pathname === '/showlessons';
  const showLessonCfIsActive = location.pathname === '/showlessonscf';
  const LessonsGameFunctionalRulesIsActive = location.pathname === '/LessonsGameFunctionalRules';
  const LessonsGameTipeAccountIsActive = location.pathname === '/LessonsGameTipeAccount';
   const LessonsGameAccountsPlanIsActive = location.pathname === '/LessonsGameAccountsPlan';

 const path = location.pathname.toLowerCase();

const showMenuFooter = (
  path === '/about' ||
  path === '/cariere' ||
  path === '/feedback' ||
  path === '/cursuri-prezentare' ||
  path === '/jocuri-prezentare' ||
  path === '/faq' ||
  path === '/termeni' ||
  path === '/politica' ||
  path === '/politicacookies' ||
  path === '/gdpr' ||
  path === '/anpc' ||
  path === '/ajutor'
);





const GameFunctionalRulesIsActive = location.pathname === '/GameFunctionalRules';
const GameTipeAccountIsActive = location.pathname === '/GameTipeAccount';
const GameAccountsPlanIsActive = location.pathname === '/GameAccountsPlan';

const BlogIsActive = location.pathname === '/blog';
  const ViewplansActive = location.pathname === '/viewplans';
  const FinalofferActive = location.pathname === '/finaloffer';
  const PaymentpageActive = location.pathname === '/paymentpage';

  const functionalpageloginActive = location.pathname === '/functionalpagelogin';
 

 const CheckCertificationIsActive = location.pathname === '/check-certification';
  const FacturareActive = location.pathname === '/facturare';
  const redirectingActive = location.pathname === '/redirecting'; // 👈 ADĂUGAT
  const mentenanceActive = location.pathname === '/mentenance';


  const userPageActive = location.pathname === '/userpage';


  


  const cursuriActive = location.pathname === '/cursuri';
    const DiplomaIsActive = location.pathname === '/diploma';
  const DiplomeIsActive = location.pathname === '/diplome';
  const CoursesProgressActive = location.pathname === '/courses-progress';
  const MedalsActive = location.pathname === '/medals';

  
  const ShowgamesIsActive = location.pathname === '/showgames';
  const SetariIsActive = location.pathname === '/setari';

const ClasamentActive = location.pathname === '/clasament';










  const hideHeader = (
    location.pathname === '/' ||
    lessonIsActive ||
    lessonCfIsActive ||
    ViewplansActive ||
    functionalpageloginActive ||
    BlogIsActive ||
    CheckCertificationIsActive ||
    FinalofferActive ||
    PaymentpageActive ||
    GameFunctionalRulesIsActive ||
    GameTipeAccountIsActive ||
    GameAccountsPlanIsActive ||
    FacturareActive ||
    showLessonIsActive ||
    showLessonCfIsActive ||
    LessonsGameFunctionalRulesIsActive ||
    LessonsGameTipeAccountIsActive ||
    LessonsGameAccountsPlanIsActive ||
    ShowgamesIsActive ||
    SetariIsActive ||
    mentenanceActive ||
    userPageActive ||
    ClasamentActive ||
    cursuriActive ||
    DiplomaIsActive ||
    DiplomeIsActive ||
    CoursesProgressActive ||
    MedalsActive ||
    redirectingActive ||
    location.pathname === '/planlunar' ||
    location.pathname === '/plananual' ||
    location.pathname === '/plangratuit' ||
    location.pathname === '/quiz-start' // ascunde header pe pagina quiz
  );

  const hideFooter = (
    location.pathname === '/' ||
    location.pathname === '/quiz-start' ||
    lessonIsActive ||
    lessonCfIsActive ||
    showLessonIsActive ||
    showLessonCfIsActive ||  
 
    functionalpageloginActive ||
    LessonsGameFunctionalRulesIsActive ||
    LessonsGameTipeAccountIsActive ||
    GameFunctionalRulesIsActive ||
    LessonsGameAccountsPlanIsActive ||
    GameTipeAccountIsActive ||
    GameAccountsPlanIsActive ||
    ShowgamesIsActive ||
    mentenanceActive ||
    location.pathname === '/setari' ||
    DiplomaIsActive ||
    FinalofferActive ||
    PaymentpageActive ||
    FacturareActive ||
    redirectingActive // 👈 ADĂUGAT
  );
  // Redirecționează userul autentificat de pe /home sau / către /functionalpagelogin
  if (!authLoading && user && (location.pathname === '/home' || location.pathname === '/')) {
    return <Navigate to="/functionalpagelogin" replace />;
  }

  return (
    <>
      {loading && location.pathname !== '/redirecting' && <LoadingOverlay />}
      {!hideHeader && (showMenuFooter ? <MenuFooter /> : <Header />)}

      <div className="d-flex flex-column v-100">
        <Routes>
           <Route path="/functionalpagelogin" element={<FunctionalPageLoginStart />} />
         
          <Route path="/quiz-start" element={<QuizStart />} />
          <Route path="/" element={<Maintenance />} />
          <Route path="home" element={<Home />} />
           <Route path="mentenance" element={<Maintenance />} />
          <Route path="/about" element={<About />} />
          <Route path="/cariere" element={<Cariere />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/cursuri-prezentare" element={<CursuriPresentation />} />
          <Route path="/jocuri-prezentare" element={<JocuriPresentation />} />

          
          <Route path="/login" element={<Login />} />
          <Route path="/emailconnect" element={<EmailConnect />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/confirmationemail" element={<ConfirmationPage />} />
          <Route path="/registrer" element={<Registrer />} />
          <Route path="/lessonscontainer" element={<LessonsContainer />} />
          
          <Route path="/blog" element={<Blog />} />
          <Route path="/check-certification" element={<CheckCertification />} />
          <Route path="/chaptercontainer" element={<Chaptercontainer />} />
          <Route path="/chaptercontainercf" element={<Chaptercontainercf />} />
          <Route path="/GameFunctionalRules" element={<GameFunctionalRules />} />
          <Route path="/GameTipeAccount" element={<GameTipeAccount />} />
          <Route path="/GameAccountsPlan" element={<GameAccountsPlan />} />
          
          <Route path="/faq" element={<FAQ />} />
       
          <Route path="/termeni" element={<Termeni />} />
          <Route path="/politica" element={<Politica />} />
          <Route path="/politicacookies" element={<Politicacookies />} />
          <Route path="/gdpr" element={<GDPR />} />
          <Route path="/anpc" element={<ANPC />} />
       
        
          <Route path="/viewplans" element={<Viewplans />} />
          <Route path="/finaloffer" element={<Finaloffer />} />
        
         
          <Route path="/facturare" element={<Facturare />} />
          <Route path="/resetareprogres" element={<ResetareProgres />} />
          <Route path="/paymentpage" element={<Paymentpage />} />
          <Route path="/redirecting" element={<RedirectAfterLogin />} />
        
          
          <Route path="/bazeleconta" element={<BazeleConta />} />
          <Route path="/contafinanciara" element={<ContaFinanciara />} />
          <Route path="/PageGameFinancialRulesOff" element={<PageGameFinancialRulesOff />} />
          <Route path="/PageGameTypeAccountOff" element={<PageGameTypeAccountOff />} />
          <Route path="/PageGameAccoutPlanOff" element={<PageGameAccoutPlanOff />} />
          <Route path="/setari" element={<Setari />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/planul-tau" element={<PlanulTau />} />
          <Route path="/ajutor" element={<Ajutor />} />

          <Route element={<LessonsLayout />}>
            <Route path="/userpage" element={<UserPage />} />
            <Route path="/cursuri" element={<Cursuri />} />
            <Route path="/diploma" element={<Diploma />} />
            <Route path="/diplome" element={<Diplome />} />
            <Route path="/courses-progress" element={<CoursesProgressPage />} />
            <Route path="/medals" element={<Medals />} />
            <Route path="/clasament" element={<Clasament />} />
            
            <Route path="/ajutor" element={<Ajutor />} />
          
            

            
             <Route path="/showgames" element={<Showgames />} />
            
          </Route>

          {/* Showlessons cu alt meniu */}
// ...existing code...

          <Route path="/showlessonscf" element={
            <>
              <Headerbc />
              <ShowLessonsFinanciara />
            </>
          } />


              <Route path="/LessonsGameFunctionalRules" element={
            <>
              <Headerbc />
              <LessonsGameFunctionalRules />
            </>
          } />

             <Route path="/LessonsGameTipeAccount" element={
            <>
              <Headerbc />
              <LessonsGameTipeAccount />
            </>
          } />

             <Route path="/LessonsGameAccountsPlan" element={
            <>
              <Headerbc />
              <LessonsGameAccountsPlan />
            </>
          } />

          {/* Dedicated plan pages */}
          <Route path="/planlunar" element={<PlanLunar />} />
          <Route path="/plananual" element={<PlanAnual />} />
          <Route path="/plangratuit" element={<PlanGratuit />} />



   


        </Routes>
      </div>

      {!hideFooter && <Footer />}
    </>
  );
}



function App() {
  return (
    <AuthProvider>
      <DarkModeProvider>
        <Router>
          <ScrollToTop />
          <AppContent />
        </Router>
      </DarkModeProvider>
    </AuthProvider>
  );
}




// Componenta principală




export default App;
